import { Routes } from '@angular/router';

import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';
import { AuthGuard } from './security/authGuard';
import { AdminAuthGuard } from './security/adminAuthGuard';
import { AiAssistantComponent } from './shared/AIAssistant/ai-assistant/ai-assistant.component';
import { AiAgentComponent } from './shared/AIAgent/ai-agent/ai-agent.component';
import { ClaireSavedChatsComponent } from './shared/AIAgent/claire-saved-chats/claire-saved-chats.component';

export const AppRoutes: Routes = [
	{
		path: 'admin',
		component: AdminLayoutComponent,
		loadChildren: () => import('./administration/administration.module').then((m) => m.AdministrationModule),
		canActivate: [AdminAuthGuard],
	},
	{
		path: '',
		redirectTo: 'dashboard',
		pathMatch: 'full',
	},
	{
		path: '',
		component: AuthLayoutComponent,
		children: [
			{
				path: 'authentication',
				loadChildren: () => import('./authentication/authentication.module').then((m) => m.AuthenticationModule),
			},
		],
	},
	{
		path: '',
		component: AdminLayoutComponent,
		children: [
			{
				path: 'claire',
				component: AiAgentComponent,
				canActivate: [AuthGuard],
			},
			// EN-5079: the Claire submenu. New chat is the same page as claire; a saved chat reopens at
			// claire/c/:conversationId; Saved chats is the user's list.
			{
				path: 'claire/new',
				component: AiAgentComponent,
				canActivate: [AuthGuard],
			},
			{
				path: 'claire/c/:conversationId',
				component: AiAgentComponent,
				canActivate: [AuthGuard],
			},
			{
				path: 'claire/saved',
				component: ClaireSavedChatsComponent,
				canActivate: [AuthGuard],
			},
			// Pre-rebrand path (EN-4447); keeps old bookmarks and shared links working.
			{
				path: 'ai-agent',
				redirectTo: 'claire',
				pathMatch: 'full',
			},
			{
				path: '',
				loadChildren: () => import('./client/client.module').then((m) => m.ClientModule),
				canActivate: [AuthGuard],
			},
		],
	},
	{
		path: 'ai-chat',
		component: AiAssistantComponent,
	},
];
